<p-toast></p-toast>
<p-confirmDialog header="Confirmation" key="basic" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-menu #menuContextuelEtape popup="popup" [model]="contenuMenuContextuelEtape"></p-menu>
<p-menu #menuContextuelPiece popup="popup" [model]="contenuMenuContextuelPiece"></p-menu>
<p-menu #menuContextuelNote popup="popup" [model]="contenuMenuContextuelNote"></p-menu>
<p-menu #menuContextuelSuppr popup="popup" [model]="contenuMenuContextuelSuppr"></p-menu>

<p-sidebar [(visible)]="afficherSidebarPieces" position="right" [style]="{width:'80vw'}" (onHide)="fermerSidebarPieces()">
	<ng-template pTemplate="header">
		<div class="flex align-items-center gap-2">
			<i class="pi pi-box"></i>
			<span class="font-bold">Pièces - Étape #{{etapeCourantePourPieces?.noEtape}}</span>
		</div>
	</ng-template>
	
	<div *ngIf="etapeCourantePourPieces" class="flex flex-wrap align-content-center justify-content-between mt-4 pt-3 mb-3">
		<div>
			<span class="p-input-icon-left">
				<i class="pi pi-search"></i>
				<input pInputText type="text"
					(input)="$any($event.target).value"
					placeholder="Recherche..." />
			</span>
		</div>
		<h5 class="titreTableau m-0">Pièces ({{etapeCourantePourPieces.pieces?.length || 0}})</h5>
		<div></div>
	</div>

	<p-table *ngIf="etapeCourantePourPieces" [value]="etapeCourantePourPieces.pieces" 
		dataKey="pieceBonTravailId" tableStyleClass="tableNormale" autoLayout="true"
		[rowHover]="true" [filterDelay]="0"
		[globalFilterFields]="['item.numero','item.description','quantite']">
		<ng-template pTemplate="header">
			<tr>
				<th pSortableColumn="noEtape">
					<div class="flex justify-content-between align-items-center">
						#
						<p-sortIcon field="noEtape"></p-sortIcon>
					</div>
				</th>
				<th pSortableColumn="item.numero">
					<div class="flex justify-content-between align-items-center">
						Numéro
						<p-sortIcon field="item.numero"></p-sortIcon>
					</div>
				</th>
				<th pSortableColumn="item.description">
					<div class="flex justify-content-between align-items-center">
						Description
						<p-sortIcon field="item.description"></p-sortIcon>
					</div>
				</th>
				<th pSortableColumn="item.marque">
					<div class="flex justify-content-between align-items-center">
						Marque
						<p-sortIcon field="item.marque"></p-sortIcon>
					</div>
				</th>
				<th pSortableColumn="item.modele">
					<div class="flex justify-content-between align-items-center">
						Modèle
						<p-sortIcon field="item.modele"></p-sortIcon>
					</div>
				</th>
				<th pSortableColumn="quantite">
					<div class="flex justify-content-between align-items-center">
						Qte nécessaire
						<p-sortIcon field="quantite"></p-sortIcon>
					</div>
				</th>
				<th pSortableColumn="qteInventaire">
					<div class="flex justify-content-between align-items-center">
						Qte inventaire
						<p-sortIcon field="qteInventaire"></p-sortIcon>
					</div>
				</th>
				<th pSortableColumn="note">
					<div class="flex justify-content-between align-items-center">
						Note
						<p-sortIcon field="note"></p-sortIcon>
					</div>
				</th>
				<th style="min-width: 5rem; width: 5rem;"></th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" let-entree>
			<tr>
				<td><span class="clickable-etape" (click)="scrollToEtape(entree.noEtape)">{{entree.noEtape}}</span></td>
				<td>{{entree.item?.numero}}</td>
				<td>{{entree.item?.description}}</td>
				<td>{{entree.item?.marque}}</td>
				<td>{{entree.item?.modele}}</td>
				<td>{{entree.quantite}}</td>
				<td>
					<span [ngClass]="entree.qteInventaire && entree.qteInventaire > 0 ? entree.qteInventaire >= entree.quantite ? 'inventaire disponible' : 'inventaire insuffisant' : 'inventaire nondisponible'">
						{{entree.qteInventaire}}
					</span>
				</td>
				<td>
					<span class="formatted-text">{{entree.note}}</span>
					<p-button *ngIf="!modeConsultation()" icon="pi pi-pencil"
						[outlined]="true"
						severity="primary"
						(onClick)="modifierNotePiece($event, entree)"></p-button>
				</td>
				<td>
					<p-button *ngIf="!modeConsultation()" icon="pi pi-trash"
						severity="danger"
						(onClick)="supprimerPieces($event, [entree])"></p-button>
					<p-button *ngIf="modeConsultation()" icon="pi pi-bars"
						severity="secondary"
						(onClick)="surMenuContextuelPiece($event, entree)"></p-button>
				</td>
			</tr>
		</ng-template>
		<ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="9">Aucune pièce.</td>
			</tr>
		</ng-template>
	</p-table>
</p-sidebar>

<p-card *ngIf="!EstCharge()">
	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 my-2 col-12 text-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
	</div>
</p-card>

<p-confirmDialog #confirmDialog key="transformer-soumission-bon-travail">
    <ng-template pTemplate="headless" let-message>
        <div class="flex flex-column gap-2 border-round p-3 pb-6">
            <span>{{ message.message }}</span>
            <label for="commentaire">Commentaire:</label>
            <textarea pInputTextarea id="commentaire" [(ngModel)]="commentaire"></textarea>
            <div class="flex align-items-center gap-2 mt-3">
                <p-splitButton label="Envoyer" [model]="splitBtnItems" (onClick)="Approbation()" />
                <p-button (onClick)="confirmDialog.close($event)" label="Annuler" [outlined]="true" />
            </div>
        </div>
    </ng-template>
</p-confirmDialog>

<div *ngIf="EstCharge()">
		<p-card styleClass="mb-4">
			<div class="flex align-items-start gap-3 flex-wrap mb-3">
				@if (bonTravail().item?.photoId) {
					@defer (on viewport) {
						<app-image-loader
							[documentId]="bonTravail().item.photoId"
							[width]="56"
							[height]="56"
							[title]="bonTravail().item.numero" />
					}
					@placeholder {
						<div class="flex align-items-center justify-content-center" style="height: 56px; width: 56px;">
							<p-skeleton width="56px" height="56px"></p-skeleton>
						</div>
					}
				}
				<div class="flex flex-column gap-2 min-w-0 flex-1">
					<div class="flex flex-wrap align-items-center gap-2">
						<h5 class="mb-0">
							{{ bonTravail().indSoumission ? 'Soumission' : 'Bon de travail' }}
							{{ bonTravail().numero | valeurVide }}
						</h5>
						<span [class]="'statut ' + bonTravail().statut.nom.toLowerCase().replace(' ','')">
							{{ bonTravail().statut.nom }}
						</span>
					</div>
					<span class="champConsultation text-overflow-ellipsis overflow-hidden">
						{{ bonTravail().item?.description | valeurVide }}
					</span>
					@if (modeApercu) {
						<span class="flex align-items-center gap-2">
							<i class="pi pi-id-card"></i>
							<a class="lienFicheComplete" (click)="ouvrirFicheComplete()">Aller à la fiche complète</a>
						</span>
					}
				</div>
			</div>

			<h6 *ngIf="bonTravail().dateEnvoi" class="mb-3">
				<i class="pi pi-send" style="font-size: 0.8rem"></i>
				Assigné le : {{ bonTravail().dateDebut | date:'yyyy-MM-dd HH:mm:ss' }}
			</h6>

			<p-menubar autoDisplay="false" [model]="menu" *ngIf="!modeApercu">
				<ng-template pTemplate="end">
					<p-tag
						[severity]="peutModifierContenu ? 'success' : 'secondary'"
						[icon]="peutModifierContenu ? 'pi pi-pencil' : 'pi pi-lock'"
						[value]="peutModifierContenu ? 'Modifiable' : 'Non modifiable'"
						styleClass="detail-bt-edition-marker text-sm cursor-help white-space-nowrap"
						[pTooltip]="obtenirTooltipStatutEdition()"
						tooltipPosition="bottom"
						[fitContent]="true" />
				</ng-template>
			</p-menubar>
		</p-card>
	</div>

<app-document-historique
	[(visible)]="afficherHistorique"
	[typeLien]="ETypeLienDocument.BonTravail"
	[entityId]="bonTravailId"
	[canRestore]="peutModifierContenu"
	(restored)="surHistoriqueRestaure()">
</app-document-historique>


<div *ngIf="EstCharge()">
		<p-tabView [scrollable]="true" orientation="left">
			<p-tabPanel header="Informations générales" leftIcon="pi pi-info-circle">
				<div class="detail-bt-header-layout mb-3">
					<div class="detail-bt-header-left flex flex-column gap-3">
						<p-card styleClass="detail-bt-info-card">
							<ng-template pTemplate="header">
								<div class="flex align-items-center gap-2 px-3 pt-3">
									<i class="pi pi-truck" aria-hidden="true"></i>
									<span class="font-semibold">Informations de l'unité</span>
								</div>
							</ng-template>
							<div class="fluid formgrid grid">
								<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-4">
									<label for="numeroItem">Unité</label>
									<div class="flex align-items-center gap-2 cursor-pointer" [routerLink]="'/item/' + bonTravail().item.itemId">
										<div *ngIf="bonTravail().item.photoId">
											@defer (on viewport) {
											<app-image-loader [documentId]="bonTravail().item.photoId" [width]="45" [height]="45" [title]="bonTravail().item.numero"></app-image-loader>
											}
											@placeholder {
												<div class="flex align-items-center justify-content-center" style="height: 45px; width: 45px;">
													<p-skeleton width="45px" height="45px"></p-skeleton>
												</div>
											}
										</div>
										<div class="flex flex-column gap-2">
											<a class="font-bold" [routerLink]="'/item/' + bonTravail().item.itemId">
												<span class="champConsultation">{{bonTravail().item.numero | valeurVide}}</span>
											</a>
											<span class="champConsultation">{{bonTravail().item.description | valeurVide}}</span>
										</div>
									</div>
								</div>
								<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-4">
									<label for="heuresItem">Heures début (compteur/réel)</label>
									@if (peutModifierContenu) {
										<app-releve-bt-selector
											[bonTravailId]="bonTravailId"
											[itemId]="bonTravail().item.itemId"
											type="heure"
											cote="debut"
											[valeur]="bonTravail().heuresDebutCompteur"
											[valeurReelle]="bonTravail().heuresDebutReelles"
											[placeholder]="bonTravail().item.heuresCompteur"
											[releveLie]="bonTravail().releveHeureDebut"
											[lectureSeule]="false"
											[afficherLabel]="false"
											[editionAuClic]="true"
											(valeurSave)="surSauvegardeReleveCompteur($event, 'heuresdebutcompteur', bonTravail().heuresDebutCompteur)"
											(releveLieChange)="surLiaisonReleveChange($any($event), 'debut', 'heure')" />
									} @else {
										<span class="champConsultation">{{bonTravail().heuresDebutCompteur | valeurVide}} / {{bonTravail().heuresDebutReelles | valeurVide}}</span>
										@if (bonTravail().releveHeureDebut) {
											<p-tag severity="info" icon="pi pi-link" [value]="(bonTravail().releveHeureDebut.date | date:'yyyy-MM-dd') + ' — relevé lié'"></p-tag>
										}
									}
								</div>
								<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-4">
									<label for="heuresFinItem">Heures fin (compteur/réel)</label>
									@if (peutModifierContenu && !bonTravail().indSoumission) {
										<app-releve-bt-selector
											[bonTravailId]="bonTravailId"
											[itemId]="bonTravail().item.itemId"
											type="heure"
											cote="fin"
											[valeur]="bonTravail().heuresCompteur"
											[valeurReelle]="bonTravail().heuresReelles"
											[placeholder]="bonTravail().item.heuresCompteur"
											[releveLie]="bonTravail().releveHeureFin"
											[lectureSeule]="false"
											[afficherLabel]="false"
											[editionAuClic]="true"
											(valeurSave)="surSauvegardeReleveCompteur($event, 'heurescompteur', bonTravail().heuresCompteur)"
											(releveLieChange)="surLiaisonReleveChange($any($event), 'fin', 'heure')" />
									} @else {
										<span class="champConsultation">{{bonTravail().heuresCompteur | valeurVide}} / {{bonTravail().heuresReelles | valeurVide}}</span>
										@if (bonTravail().releveHeureFin) {
											<p-tag severity="info" icon="pi pi-link" [value]="(bonTravail().releveHeureFin.date | date:'yyyy-MM-dd') + ' — relevé lié'"></p-tag>
										}
									}
								</div>
								<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-4">
									<label for="kmItem">KM début (compteur/réel)</label>
									@if (peutModifierContenu) {
										<app-releve-bt-selector
											[bonTravailId]="bonTravailId"
											[itemId]="bonTravail().item.itemId"
											type="km"
											cote="debut"
											[valeur]="bonTravail().kmDebutCompteur"
											[valeurReelle]="bonTravail().kmDebutReels"
											[placeholder]="bonTravail().item.kmCompteur"
											[releveLie]="bonTravail().releveKmDebut"
											[lectureSeule]="false"
											[afficherLabel]="false"
											[editionAuClic]="true"
											(valeurSave)="surSauvegardeReleveCompteur($event, 'kmdebutcompteur', bonTravail().kmDebutCompteur)"
											(releveLieChange)="surLiaisonReleveChange($any($event), 'debut', 'km')" />
									} @else {
										<span class="champConsultation">{{bonTravail().kmDebutCompteur | valeurVide}} / {{bonTravail().kmDebutReels | valeurVide}}</span>
										@if (bonTravail().releveKmDebut) {
											<p-tag severity="info" icon="pi pi-link" [value]="(bonTravail().releveKmDebut.date | date:'yyyy-MM-dd') + ' — relevé lié'"></p-tag>
										}
									}
								</div>
								<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-4">
									<label for="kmFinItem">KM fin (compteur/réel)</label>
									@if (peutModifierContenu && !bonTravail().indSoumission) {
										<app-releve-bt-selector
											[bonTravailId]="bonTravailId"
											[itemId]="bonTravail().item.itemId"
											type="km"
											cote="fin"
											[valeur]="bonTravail().kmCompteur"
											[valeurReelle]="bonTravail().kmReels"
											[placeholder]="bonTravail().item.kmCompteur"
											[releveLie]="bonTravail().releveKmFin"
											[lectureSeule]="false"
											[afficherLabel]="false"
											[editionAuClic]="true"
											(valeurSave)="surSauvegardeReleveCompteur($event, 'kmcompteur', bonTravail().kmCompteur)"
											(releveLieChange)="surLiaisonReleveChange($any($event), 'fin', 'km')" />
									} @else {
										<span class="champConsultation">{{bonTravail().kmCompteur | valeurVide}} / {{bonTravail().kmReels | valeurVide}}</span>
										@if (bonTravail().releveKmFin) {
											<p-tag severity="info" icon="pi pi-link" [value]="(bonTravail().releveKmFin.date | date:'yyyy-MM-dd') + ' — relevé lié'"></p-tag>
										}
									}
								</div>
							</div>
						</p-card>

						<p-card styleClass="detail-bt-info-card">
							<ng-template pTemplate="header">
								<div class="flex align-items-center gap-2 px-3 pt-3">
									<i class="pi pi-wrench" aria-hidden="true"></i>
									<span class="font-semibold">Informations du bon de travail</span>
								</div>
							</ng-template>
							<div class="fluid formgrid grid">
								<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-6">
									<label for="kmItem">Type</label>
									<app-inline-editable-field
										[value]="bonTravail().type"
										type="selectButton"
										[readonly]="!peutModifierContenu"
										[options]="typesBonTravail"
										optionLabel="label"
										optionValue="value"
										[displayFn]="afficherType"
										[pulseToken]="fieldPulseTokens['header.type']"
										(save)="sauvegarderChamp('type', $event); surChangementTypeBonTravail()">
									</app-inline-editable-field>
								</div>
								<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-6">
									<label for="lastname">Raison</label>
									<app-inline-editable-field
										[value]="bonTravail().raison"
										type="select"
										[readonly]="!peutModifierContenu"
										[options]="raisons"
										optionLabel="description"
										dataKey="raisonBonTravailId"
										[filter]="true"
										filterBy="code,description"
										placeholder="Sélectionner une raison..."
										[displayFn]="afficherRaison"
										[pulseToken]="fieldPulseTokens['header.raison']"
										(save)="sauvegarderChamp('raison', $event)">
									</app-inline-editable-field>
								</div>
								<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-6">
									<label for="contreMaitre">Contre-Maître@if (peutModifierContenu) {<span class="requis">*</span>}</label>
									<app-inline-editable-field
										[value]="bonTravail().contreMaitre"
										type="select"
										[readonly]="!peutModifierContenu"
										[options]="employes"
										optionLabel="prenomNom"
										dataKey="employeId"
										[filter]="true"
										filterBy="prenom,nom,prenomNom,initiales,noEmploye"
										[showClear]="true"
										placeholder="Sélectionner un contre-maître..."
										[displayFn]="afficherEmploye"
										[pulseToken]="fieldPulseTokens['header.contremaitre']"
										(save)="sauvegarderChamp('contreMaitre', $event)">
									</app-inline-editable-field>
								</div>

								@if (bonTravail().type == 1) {
									<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-6">
										<label for="mecanicien">Mécanicien</label>
										<app-inline-editable-field
											[value]="bonTravail().mecanicien"
											type="select"
											[readonly]="!peutModifierContenu"
											[options]="employes"
											optionLabel="prenomNom"
											dataKey="employeId"
											[filter]="true"
											filterBy="prenom,nom,prenomNom,initiales,noEmploye"
											[showClear]="true"
											placeholder="Sélectionner un mécanicien..."
											[displayFn]="afficherEmploye"
											[pulseToken]="fieldPulseTokens['header.mecanicien']"
											(save)="sauvegarderChamp('mecanicien', $event)">
										</app-inline-editable-field>
									</div>
								}

								@if (bonTravail().type == 2) {
									<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-6">
										<label for="lastname">Fournisseur</label>
										<app-inline-editable-field
											[value]="bonTravail().fournisseur"
											type="select"
											[readonly]="!peutModifierContenu"
											[options]="fournisseurs"
											optionLabel="nom"
											dataKey="fournisseurId"
											[filter]="true"
											filterBy="numero,nom"
											placeholder="Sélectionner un fournisseur..."
											[displayFn]="afficherNom"
											[pulseToken]="fieldPulseTokens['header.fournisseur']"
											(save)="sauvegarderChamp('fournisseur', $event)">
										</app-inline-editable-field>
									</div>
								}

								<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-6">
									<label for="contreMaitre">Emplacement</label>
									<app-inline-editable-field
										[value]="bonTravail().emplacement"
										type="select"
										[readonly]="!peutModifierContenu"
										[options]="emplacements"
										optionLabel="nom"
										dataKey="emplacementId"
										[filter]="true"
										filterBy="nom"
										[showClear]="true"
										placeholder="Sélectionner un emplacement..."
										[displayFn]="afficherNom"
										[pulseToken]="fieldPulseTokens['header.emplacement']"
										(save)="sauvegarderChamp('emplacement', $event)">
									</app-inline-editable-field>
								</div>
								@if (!bonTravail().indSoumission) {
									<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-6">
										<label for="kmItem">Montant Total</label>
										<span class="champConsultation">{{bonTravail().coutReelPieces | valeurVide}}</span>
									</div>
									<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-6">
										<label for="kmItem">Heures Total</label>
										<span class="champConsultation">{{bonTravail().coutReelHeures | valeurVide}}</span>
									</div>
								}
								<div class="sihc-field flex flex-column gap-2 mb-2 col-12 md:col-6 detail-bt-note-quill">
									<label for="note">Note du bon de travail</label>
									@if (!peutModifierContenu || !noteEnEdition) {
										<div class="detail-bt-note-quill__display w-full min-w-0"
											  [class.cursor-pointer]="peutModifierContenu"
											  [class.detail-bt-note-quill__display--editable]="peutModifierContenu"
											  (click)="peutModifierContenu && (noteEnEdition = true)">
											@if (bonTravail().note) {
												<sihc-quill-view
													[modules]="sdb.modules"
													[content]="bonTravail().note"
													[style]="noteQuillViewStyle" />
											} @else {
												<span class="champConsultation">—</span>
											}
										</div>
									} @else {
										<div class="flex flex-column gap-2 w-full min-w-0">
											<quill-editor
												id="note"
												[modules]="sdb.modules"
												[(ngModel)]="bonTravail().note"
												placeholder="—"
												[style]="noteQuillEditorStyle" />
											<p-button
												label="Enregistrer la note"
												icon="pi pi-check"
												styleClass="p-button-sm"
												(onClick)="sauvegarderChamp('note', bonTravail().note); noteEnEdition = false">
											</p-button>
										</div>
									}
								</div>

								<div class="sihc-field flex flex-column gap-2 my-2 col-12">
									<label for="emplacement">Note mécanique de l'unité</label>
									<span class="champConsultation" style="white-space: pre-line; font-size: 1.5rem; color: red;">{{bonTravail().item.noteMecanique | valeurVide}}</span>
								</div>
							</div>
						</p-card>
					</div>

					<div class="detail-bt-header-right">
						<p-card styleClass="detail-bt-info-card detail-bt-dates-card h-full">
							<ng-template pTemplate="header">
								<div class="flex align-items-center gap-2 px-3 pt-3">
									<i class="pi pi-calendar" aria-hidden="true"></i>
									<span class="font-semibold">Dates et avancement</span>
								</div>
							</ng-template>
							<div class="detail-bt-dates-card-body flex flex-column gap-4 h-full">
								<div class="detail-bt-dates-timeline flex flex-column gap-3">
									@for (event of events; track event.key) {
										<div class="detail-bt-date-step sihc-field flex flex-column gap-2">
											<label [for]="event.key">{{ event.label }}</label>
											<app-inline-editable-field
												[value]="bonTravail()[event.key]"
												type="date"
												[readonly]="!peutModifierContenu"
												[displayFn]="afficherDate"
												[pulseToken]="fieldPulseTokens['header.' + event.key.toLowerCase()]"
												(save)="sauvegarderChamp(event.key, $event)">
											</app-inline-editable-field>
										</div>
									}
								</div>
								<div class="detail-bt-avancement-metrics flex flex-column gap-2 pt-2 border-top-1 surface-border flex-1 justify-content-center">
									<div class="flex align-items-center justify-content-between gap-2 flex-wrap">
										<span class="font-medium">Durée des travaux</span>
										<span class="text-sm text-color-secondary font-semibold">
											{{ obtenirDureeTravaux() | valeurVide }}
										</span>
									</div>
									<div class="flex align-items-center justify-content-between gap-2 flex-wrap">
										<span class="font-medium">Avancement des travaux</span>
										<span class="text-sm text-color-secondary">
											{{ obtenirNombreEtapesCompletes() }} / {{ obtenirNombreEtapesTotal() }} étapes
										</span>
									</div>
									<p-progressBar
										[value]="obtenirPourcentageAvancementTravaux()"
										[showValue]="true"
										styleClass="detail-bt-progress" />
								</div>
							</div>
						</p-card>
					</div>
				</div>

				<p-card styleClass="mt-1">

					<!-------------  TRAVAIL  -------------->

					<div class="detail-bt-table-toolbar mt-4 pt-3 mb-3">
						<div class="detail-bt-table-toolbar__main flex flex-column md:flex-row md:align-items-center md:justify-content-between gap-3">
							<div class="flex align-items-center gap-2 min-w-0 flex-shrink-0">
								<h4 class="titreTableau m-0 text-lg font-semibold line-height-3">Travaux</h4>
								<p-tag
									[value]="(bonTravail().etapes?.length ?? 0).toString()"
									severity="secondary"
									styleClass="text-xs font-normal"
									[pTooltip]="'Nombre d\'étapes'"
									tooltipPosition="top">
								</p-tag>
							</div>
							<div class="flex flex-column sm:flex-row flex-wrap align-items-stretch sm:align-items-center gap-2 w-full md:w-auto md:flex-1 md:justify-content-end min-w-0">
								<span class="p-input-icon-left detail-bt-table-toolbar__search w-full sm:w-auto">
									<i class="pi pi-search"></i>
									<input
										pInputText
										type="text"
										class="w-full"
										(input)="dtTravail.filterGlobal($event.target.value, 'contains')"
										placeholder="Rechercher dans les travaux..." />
								</span>
								<p-multiSelect
									[options]="colonnesDisponibles"
									[(ngModel)]="colonnesSelectionnees"
									optionLabel="entete"
									selectedItemsLabel="{0} colonnes sélectionnées"
									[style]="{ minWidth: '12rem', maxWidth: '100%' }"
									styleClass="detail-bt-table-toolbar__columns w-full sm:w-auto"
									placeholder="Colonnes..."
									display="chip">
								</p-multiSelect>
							</div>
						</div>

						@if (!modeConsultation()) {
							<div
								class="detail-bt-table-toolbar__actions flex flex-column sm:flex-row flex-wrap align-items-stretch sm:align-items-center justify-content-between gap-2 mt-3 pt-3">
								<div class="flex flex-wrap align-items-center gap-2 min-w-0 flex-1">
									@if (selectionMultipleEtapes?.length) {
										<div class="detail-bt-table-toolbar__selection flex flex-wrap align-items-center gap-2 px-2 py-1 border-round w-full sm:w-auto">
											<span class="text-sm font-semibold white-space-nowrap">
												{{ selectionMultipleEtapes.length }} sélectionnée(s)
											</span>
											@if (peutModifierContenu) {
												<p-button
													label="Marquer fait"
													icon="pi pi-check"
													severity="success"
													styleClass="p-button-sm p-button-outlined"
													[loading]="actionGroupeeEtapeEnChargement('marquerFait')"
													[disabled]="etapesActionGroupeeDesactivee('marquerFait')"
													(onClick)="marquerEtapesSelectionCompletees(true)">
												</p-button>
												<p-button
													label="Marquer non fait"
													icon="pi pi-times"
													severity="secondary"
													styleClass="p-button-sm p-button-outlined"
													[loading]="actionGroupeeEtapeEnChargement('marquerNonFait')"
													[disabled]="etapesActionGroupeeDesactivee('marquerNonFait')"
													(onClick)="marquerEtapesSelectionCompletees(false)">
												</p-button>
												@if (!bonTravail().indSoumission) {
													<p-button
														label="Assigner mécanicien"
														icon="pi pi-user"
														severity="secondary"
														styleClass="p-button-sm p-button-outlined"
														[loading]="actionGroupeeEtapeEnChargement('mecanicien')"
														[disabled]="etapesActionGroupeeDesactivee('mecanicien')"
														(onClick)="assignerMecanicienEtapesSelectionnees()">
													</p-button>
												}
											}
											@if (estAutorise('bontravail_approuver')) {
												<p-button
													label="Convertir en manuel"
													icon="pi pi-wrench"
													severity="secondary"
													styleClass="p-button-sm p-button-outlined"
													[loading]="actionGroupeeEtapeEnChargement('convertir')"
													[disabled]="etapesActionGroupeeDesactivee('convertir')"
													(onClick)="convertirEtapesVersAut($event, selectionMultipleEtapes)">
												</p-button>
											}
											<p-button
												label="Supprimer"
												icon="pi pi-trash"
												severity="danger"
												styleClass="p-button-sm p-button-outlined"
												[loading]="actionGroupeeEtapeEnChargement('supprimer')"
												[disabled]="etapesActionGroupeeDesactivee('supprimer')"
												(onClick)="supprimerEtapes($event, selectionMultipleEtapes)">
											</p-button>
										</div>
									} @else {
										<span class="text-sm text-color-secondary">
											Sélectionnez des lignes pour les actions groupées.
										</span>
									}
								</div>
								<div class="flex justify-content-end flex-shrink-0">
									<p-button
										label="Ajouter une étape"
										icon="pi pi-plus"
										severity="success"
										styleClass="p-button-sm w-full sm:w-auto"
										(onClick)="surAjoutEtape()">
									</p-button>
								</div>
							</div>
						}
					</div>

					<p-table #dtTravail [value]="bonTravail().etapes" dataKey="etapeBonTravailId" autoLayout="true" 
						[columns]="selectedColumns"
						[(selection)]="selectionMultipleEtapes"
						(onRowSelect)="surChangementSelectionEtape()"
						(onRowUnselect)="surChangementSelectionEtape()"
						(onHeaderCheckboxToggle)="surChangementSelectionEtape()"
						(onRowReorder)="surChangementOrdreEtape($event)"
						[rowHover]="true"
						[reorderableRows]="true" 
						[scrollable]="true"
						[filterDelay]="0"
						[sortField]="'ordre'"
						[globalFilterFields]="['description','note','categorie.code','categorie.description']">
						<ng-template pTemplate="header" let-columns> 
							<tr>
								<th *ngIf="!modeConsultation()" class="etape-ordre-col"></th>
								<th *ngIf="!modeConsultation()" style="min-width: 3rem; width: 3rem;">
									<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
								</th>
								<th style="min-width: 2.5rem; width: 2.5rem;"
									pTooltip="Détails de l'étape"
									tooltipPosition="top">
									<i class="pi pi-pencil text-sm text-color-secondary" aria-hidden="true"></i>
								</th>
								<th *ngFor="let colonne of colonnesSelectionnees" [pSortableColumn]="colonne.champ">
									<div class="flex justify-content-between align-items-center">
										{{colonne.entete}}
										<p-sortIcon [field]="colonne.champ"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="fait">
									<div class="flex justify-content-between align-items-center">
										Fait
										<p-sortIcon field="fait"></p-sortIcon>
									</div>
								</th>
								<th *ngIf="!bonTravail().indSoumission" pSortableColumn="fait">
									<div class="flex justify-content-between align-items-center">
										Par
										<p-sortIcon field="fait"></p-sortIcon>
									</div>
								</th>
								<th *ngIf="bonTravail().indSoumission" style="width: 8rem;">
									A Faire
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-entree let-columns="columns" let-index="rowIndex">
							<tr
								[pReorderableRow]="index"
								(click)="basculerExpansionEtape(entree, $event)"
								class="cursor-pointer etape-travaux-row"
								tabindex="-1"
								[attr.aria-label]="'Étape ' + (entree.ordre ?? entree.noEtape)"
								[ngClass]="{
									'bg-red-100': entree.indElementMajeur && bonTravail().indSoumission,
									'etape-highlight': etapeExpandueId === entree.etapeBonTravailId,
									'surface-hover': etapeExpandueId === entree.etapeBonTravailId,
									'etape-highlight-flash': entree.etapeBonTravailId && entree.etapeBonTravailId === etapeHighlightId
								}"
								[id]="'etape-' + entree.noEtape">
								<td *ngIf="!modeConsultation()" class="etape-ordre-col" (click)="$event.stopPropagation()">
									<div
										class="etape-ordre-controls"
										[class.etape-ordre-controls--expanded]="etapeExpandueId === entree.etapeBonTravailId">
										<span
											class="pi pi-bars etape-ordre-controls__handle"
											pReorderableRowHandle
											pTooltip="Glisser pour réordonner"
											tooltipPosition="top"
											aria-label="Réordonner l'étape">
										</span>
										<div class="etape-ordre-controls__rail">
											@if (etapeExpandueId === entree.etapeBonTravailId) {
												<p-button
													icon="pi pi-angle-up"
													styleClass="p-button-text p-button-secondary p-button-sm etape-ordre-controls__btn"
													pTooltip="Étape précédente"
													tooltipPosition="top"
													[disabled]="!peutNaviguerEtapeExpandue(-1, entree.etapeBonTravailId)"
													(onClick)="naviguerEtapeExpandue(-1, entree.etapeBonTravailId)">
												</p-button>
												<p-button
													icon="pi pi-angle-down"
													styleClass="p-button-text p-button-secondary p-button-sm etape-ordre-controls__btn"
													pTooltip="Étape suivante"
													tooltipPosition="top"
													[disabled]="!peutNaviguerEtapeExpandue(1, entree.etapeBonTravailId)"
													(onClick)="naviguerEtapeExpandue(1, entree.etapeBonTravailId)">
												</p-button>
											} @else {
												<p-button
													icon="pi pi-angle-double-up"
													styleClass="p-button-text p-button-secondary p-button-sm etape-ordre-controls__btn"
													pTooltip="Mettre en tête"
													tooltipPosition="top"
													[disabled]="index === 0"
													(onClick)="surChangementOrdreEtape({dragIndex: index, dropIndex: 0})">
												</p-button>
												<p-button
													icon="pi pi-angle-double-down"
													styleClass="p-button-text p-button-secondary p-button-sm etape-ordre-controls__btn"
													pTooltip="Mettre en bas"
													tooltipPosition="top"
													[disabled]="index === (bonTravail().etapes.length - 1)"
													(onClick)="surChangementOrdreEtape({dragIndex: index, dropIndex: bonTravail().etapes.length - 1})">
												</p-button>
											}
										</div>
									</div>
								</td>
								<td *ngIf="!modeConsultation()" (click)="$event.stopPropagation()">
									<p-tableCheckbox [value]="entree"></p-tableCheckbox>
								</td>
								<td class="text-center">
									<i class="pi text-color-secondary text-sm"
										[class.pi-chevron-down]="etapeExpandueId === entree.etapeBonTravailId"
										[class.pi-chevron-right]="etapeExpandueId !== entree.etapeBonTravailId"
										aria-hidden="true"></i>
								</td>
								<td *ngIf="EstColonneSelectionnee('ordre')"
									[class.etape-ordre-preview]="ordreEtapeChangeEnPreview(entree)">
									<span [class.font-semibold]="ordreEtapeChangeEnPreview(entree)">
										{{ obtenirOrdreAfficheEtape(entree) }}
									</span>
								</td>
								<td *ngIf="EstColonneSelectionnee('typeEtapeBonTravail.code')">
										<span>{{entree.typeEtapeBonTravail?.code}}</span>
								</td>
								<td *ngIf="EstColonneSelectionnee('categorie')">{{entree.categorie | categorieEntretien}}</td>
								<td *ngIf="EstColonneSelectionnee('description')">
									<div>{{entree.description}}</div>
								</td>
								<td *ngIf="EstColonneSelectionnee('note')">
									<span class="formatted-text etape-row-note-preview">{{ entree.note || '—' }}</span>
									@if (!entree.indAFaire && !bonTravail().indSoumission) {
										<p-tag severity="warning" value="Ne pas faire" styleClass="ml-1 text-xs"></p-tag>
									}
								</td>
								<td>
									@if (entree.indComplete) {
										<p-tag severity="success" value="Oui" styleClass="text-xs"></p-tag>
									} @else {
										<span class="text-color-secondary text-sm">—</span>
									}
								</td>
								<td *ngIf="!bonTravail().indSoumission">
									<span class="text-sm">{{ afficherEmploye(entree.mecanicien) || '—' }}</span>
								</td>
								<td *ngIf="bonTravail().indSoumission">
									@if (entree.indAFaire) {
										<p-tag severity="info" value="Oui" styleClass="text-xs"></p-tag>
									} @else {
										<p-tag severity="secondary" value="Non" styleClass="text-xs"></p-tag>
									}
								</td>
							</tr>
							@if (bonTravail().indSoumission && etapeExpandueId !== entree.etapeBonTravailId) {
								<tr class="etape-options-compact-row" (click)="$event.stopPropagation()">
									<td [attr.colspan]="nombreColonnesTableauTravail()" class="py-0 px-2 border-none">
										@if (etapeAfficheOptionsCompactes(entree)) {
											<option-etape-bon-travail
												[compact]="true"
												[options]="entree.optionEtapeBonTravails"
												[optionSelectionnee]="entree.optionEtapeBonTravailId"
												[readonly]="true">
											</option-etape-bon-travail>
										} @else {
											<span class="text-sm text-color-secondary py-0.5 px-1 inline-block">
												Aucune variante — ouvrir l'étape pour en ajouter
											</span>
										}
									</td>
								</tr>
							}
							<tr *ngIf="!bonTravail().indSoumission && obtenirOptionSelectionnee(entree)">
								<td [attr.colspan]="modeConsultation() ? 10 : 11">
									<div class="flex gap-2">
										 <i class="pi pi-angle-up mr-2"></i> Informations soumission : {{obtenirOptionSelectionnee(entree)?.description}} - {{obtenirOptionSelectionnee(entree)?.montantPieces ?? 0 | number : '1.2-2'}} $ - {{obtenirOptionSelectionnee(entree)?.nbHeures ?? 0 | number : '1.2-2'}} heures
									</div>
								</td>
							</tr>
							@if (etapeExpandueId === entree.etapeBonTravailId) {
								<tr>
									<td [attr.colspan]="nombreColonnesTableauTravail()" class="surface-ground border-none">
										<div class="etape-detail-panel py-3 px-2 md:px-3" (click)="$event.stopPropagation()">
											<div class="etape-detail-panel__header flex flex-column md:flex-row md:align-items-center md:justify-content-between gap-3">
												<div class="flex flex-wrap align-items-center gap-2 min-w-0">
													<p-tag severity="secondary" [value]="'#' + obtenirOrdreAfficheEtape(entree)" styleClass="text-xs"></p-tag>
													@if (entree.typeEtapeBonTravail?.description || entree.typeEtapeBonTravail?.code) {
														<p-tag [value]="entree.typeEtapeBonTravail.description || entree.typeEtapeBonTravail.code" styleClass="text-xs"></p-tag>
													}
													@if (entree.indElementMajeur && bonTravail().indSoumission) {
														<p-tag severity="danger" value="Élément majeur" styleClass="text-xs"></p-tag>
													}
												</div>
												<div class="flex flex-wrap gap-2 align-items-center">
													@if (!modeConsultation() && !bonTravail().indSoumission && peutModifierContenu) {
														<p-button
															label="Ajouter une pièce"
															icon="pi pi-plus"
															styleClass="p-button-sm p-button-outlined"
															(onClick)="ajouterPieceEtape(entree)">
														</p-button>
													}
													<p-button
														label="Actions"
														icon="pi pi-ellipsis-v"
														styleClass="p-button-sm p-button-outlined p-button-secondary"
														(onClick)="surMenuContextuelEtape($event, entree)">
													</p-button>
													@if (!modeConsultation() && peutModifierContenu) {
														<p-button
															label="Supprimer"
															icon="pi pi-trash"
															severity="danger"
															styleClass="p-button-sm p-button-outlined"
															(onClick)="supprimerEtapes($event, [entree])">
														</p-button>
													}
												</div>
											</div>

											<p-divider styleClass="my-3"></p-divider>

											<div class="grid formgrid">
												<div class="col-12 field mb-3">
													<label class="text-sm font-medium mb-2 block">Description</label>
													<app-inline-editable-field
														[value]="entree.description"
														type="text"
														[readonly]="!peutModifierDescriptionCategorieEtape(entree)"
														[pulseToken]="fieldPulseTokens['etape.' + entree.etapeBonTravailId + '.description']"
														(save)="sauvegarderEtapeChamp(entree.etapeBonTravailId, 'description', $event)">
													</app-inline-editable-field>
												</div>
												<div class="col-12 md:col-6 field mb-3">
													<label class="text-sm font-medium mb-2 block">Catégorie</label>
													<app-inline-editable-field
														[value]="entree.categorie"
														type="select"
														[readonly]="!peutModifierDescriptionCategorieEtape(entree)"
														[options]="categoriesEntretien"
														optionLabel="description"
														dataKey="categorieEntretienId"
														[filter]="true"
														filterBy="code,description"
														placeholder="Sélectionner une catégorie..."
														[displayFn]="afficherCategorieEntretien"
														[pulseToken]="fieldPulseTokens['etape.' + entree.etapeBonTravailId + '.categorie']"
														(save)="sauvegarderEtapeChamp(entree.etapeBonTravailId, 'categorie', $event)">
													</app-inline-editable-field>
												</div>
												<div class="col-12 field mb-3">
													<label class="text-sm font-medium mb-2 block">Note</label>
													<app-inline-editable-field
														[value]="entree.note"
														type="textarea"
														[readonly]="!peutModifierContenu"
														[pulseToken]="fieldPulseTokens['etape.' + entree.etapeBonTravailId + '.note']"
														(save)="sauvegarderNoteEtape(entree, $event)">
													</app-inline-editable-field>
													@if (peutModifierContenu && estAutorise('item_note_creer')) {
														<div class="flex align-items-center gap-2 mt-2 flex-wrap">
															<p-inputSwitch
																[(ngModel)]="etapeAjouterNoteFiche[entree.etapeBonTravailId]"
																[inputId]="'etape-note-fiche-' + entree.etapeBonTravailId"
																(onChange)="onEtapeAjouterNoteFicheChange($event.checked, entree)">
															</p-inputSwitch>
															<label [for]="'etape-note-fiche-' + entree.etapeBonTravailId" class="text-sm text-color-secondary mb-0 cursor-pointer">
																Ajouter à la fiche de l'unité lors de l'enregistrement
															</label>
														</div>
													}
												</div>
												@if (estEtapeEC(entree)) {
													<div class="col-12 md:col-4 field mb-3">
														<label class="text-sm font-medium mb-2 block">Sévérité</label>
														<div class="flex align-items-center min-h-3rem">
															<app-inline-editable-field
																class="w-full"
																[value]="entree.entretienCorrectif.severite"
																type="select"
																[readonly]="!peutModifierContenu"
																[options]="severites"
																optionLabel="nom"
																dataKey="severiteId"
																[filter]="true"
																filterBy="nom"
																placeholder="Sélectionner une sévérité..."
																[displayFn]="afficherSeverite"
																[pulseToken]="fieldPulseTokens['etape.' + entree.etapeBonTravailId + '.correctifseverite']"
																(save)="sauvegarderCorrectifChamp(entree, 'correctifSeverite', $event)">
															</app-inline-editable-field>
														</div>
													</div>
												}
												<div class="col-12 md:col-4 field mb-3">
													<label class="text-sm font-medium mb-2 block">Complétée</label>
													<div class="flex align-items-center gap-2 min-h-3rem">
														<p-checkbox
															[disabled]="!peutModifierContenu"
															[(ngModel)]="entree.indComplete"
															[binary]="true"
															(onChange)="sauvegarderEtapeChamp(entree.etapeBonTravailId, 'indComplete', entree.indComplete)">
														</p-checkbox>
														<span class="text-sm text-color-secondary">{{ entree.indComplete ? 'Oui' : 'Non' }}</span>
													</div>
												</div>
												@if (estEtapeEC(entree)) {
													<div class="col-12 md:col-4 field mb-3">
														<label class="text-sm font-medium mb-2 block">Pièce en commande</label>
														<div class="flex align-items-center gap-2 min-h-3rem">
															<p-checkbox
																[disabled]="!peutModifierContenu"
																[(ngModel)]="entree.entretienCorrectif.indPieceEnCommande"
																[binary]="true"
																(onChange)="sauvegarderCorrectifChamp(entree, 'correctifIndPieceEnCommande', entree.entretienCorrectif.indPieceEnCommande)">
															</p-checkbox>
															<span class="text-sm text-color-secondary">{{ entree.entretienCorrectif.indPieceEnCommande ? 'Oui' : 'Non' }}</span>
														</div>
													</div>
												}
												@if (!bonTravail().indSoumission) {
													<div class="col-12 md:col-6 field mb-3">
														<label class="text-sm font-medium mb-2 block">Mécanicien</label>
														<div class="flex align-items-center gap-2 flex-wrap min-h-3rem">
															<app-inline-editable-field
																class="flex-1 min-w-0"
																[value]="entree.mecanicien"
																type="select"
																[readonly]="!peutModifierContenu"
																[options]="employes"
																optionLabel="prenomNom"
																dataKey="employeId"
																[filter]="true"
																filterBy="prenom,nom,prenomNom,initiales,noEmploye"
																[showClear]="true"
																placeholder="Sélectionner un mécanicien..."
																[displayFn]="afficherEmploye"
																[pulseToken]="fieldPulseTokens['etape.' + entree.etapeBonTravailId + '.mecanicien']"
																(save)="sauvegarderEtapeChamp(entree.etapeBonTravailId, 'mecanicien', $event)">
															</app-inline-editable-field>
															@if (peutModifierContenu && entree.mecanicien) {
																<p-button
																	icon="pi pi-copy"
																	styleClass="p-button-text p-button-secondary p-button-sm"
																	pTooltip="Copier le mécanicien"
																	tooltipPosition="top"
																	(onClick)="copierMecanicien(entree)">
																</p-button>
															}
														</div>
													</div>
												}
												@if (bonTravail().indSoumission) {
													<div class="col-12 md:col-8 field mb-3">
														<label class="text-sm font-medium mb-2 block">À faire</label>
														<div class="flex align-items-center gap-2 h-3rem">
															<p-checkbox
																[disabled]="bonTravail().statut.statutId == EStatuts.Complete || modeConsultation() || !peutModifierContenu"
																[(ngModel)]="entree.indAFaire"
																[binary]="true"
																(onChange)="sauvegarderEtapeChamp(entree.etapeBonTravailId, 'indAFaire', entree.indAFaire); CalculTotal()">
															</p-checkbox>
															<span class="text-sm text-color-secondary">{{ entree.indAFaire ? 'Incluse dans le total' : 'Exclue du total' }}</span>
														</div>
													</div>
													@if (estAutorise('temp_mec')) {
														<div class="col-12 md:col-4 field mb-3">
															<label class="text-sm font-medium mb-2 block">Élément majeur</label>
															<div class="flex align-items-center gap-2 h-3rem">
																<p-checkbox
																	[disabled]="modeConsultation() || !peutModifierContenu"
																	[(ngModel)]="entree.indElementMajeur"
																	[binary]="true"
																	(onChange)="sauvegarderEtapeChamp(entree.etapeBonTravailId, 'indElementMajeur', entree.indElementMajeur)">
																</p-checkbox>
																<span class="text-sm text-color-secondary">{{ entree.indElementMajeur ? 'Marquée importante' : 'Standard' }}</span>
															</div>
														</div>
													}
												}
											</div>

											@if (bonTravail().indSoumission) {
												<p-divider styleClass="my-3"></p-divider>
												<div class="flex flex-column gap-2">
													<span class="font-semibold">Options de soumission</span>
													<option-etape-bon-travail
														[(options)]="entree.optionEtapeBonTravails"
														[optionSelectionnee]="entree.optionEtapeBonTravailId"
														[radioGroupName]="'option-etape-' + entree.etapeBonTravailId"
														[readonly]="modeConsultation() || !peutModifierContenu"
														[disabled]="!entree.indAFaire"
														(onChange)="surChangementOptionSoumission(entree, $event)"
														(optionSelectionneeChange)="surSelectionOptionSoumission(entree, $event)"
														(optionSupprimee)="surSuppressionOptionSoumission(entree, $event)">
													</option-etape-bon-travail>
												</div>
											}

											@if (!bonTravail().indSoumission) {
												<p-divider styleClass="my-3"></p-divider>
												<div class="flex flex-column gap-2">
													<div class="flex align-items-center justify-content-between gap-2 flex-wrap">
														<span class="font-semibold">Pièces</span>
														<span class="text-sm text-color-secondary">{{ entree.pieces?.length || 0 }} pièce(s)</span>
													</div>
													@if (entree.pieces?.length) {
														<p-table
															[value]="entree.pieces"
															dataKey="pieceBonTravailId"
															styleClass="p-datatable-sm etape-pieces-table"
															[tableStyle]="{ 'min-width': '100%' }"
															[rowHover]="true">
															<ng-template pTemplate="body" let-piece>
																<tr>
																	<td class="white-space-nowrap font-semibold text-sm">{{ piece.item?.numero }}</td>
																	<td class="text-sm">{{ piece.item?.description }}</td>
																	<td class="text-sm text-color-secondary white-space-nowrap">{{ piece.quantite ?? '—' }}</td>
																	@if (peutModifierContenu) {
																		<td class="text-right w-3rem">
																			<p-button
																				icon="pi pi-trash"
																				severity="danger"
																				styleClass="p-button-text p-button-sm"
																				pTooltip="Supprimer"
																				tooltipPosition="top"
																				(onClick)="supprimerPieceImmediate(piece)">
																			</p-button>
																		</td>
																	}
																</tr>
															</ng-template>
														</p-table>
													} @else {
														<p class="text-sm text-color-secondary m-0">Aucune pièce associée à cette étape.</p>
													}
												</div>
											}
										</div>
									</td>
								</tr>
							}
						</ng-template>
						<ng-template *ngIf="bonTravail().indSoumission && bonTravail().etapes?.length" pTemplate="footer">
							<tr>
								<th [attr.colspan]="nombreColonnesTableauTravail() - 2"></th>
								<th alignFrozen="right" pFrozenColumn [frozen]="true" class="p-datatable-header">
									Montant Total
								</th>
								<th alignFrozen="right" pFrozenColumn [frozen]="true" class="p-datatable-header">
									Heures Total
								</th>
							</tr>
							<tr>
								<th [attr.colspan]="nombreColonnesTableauTravail() - 2"></th>
								<td alignFrozen="right" pFrozenColumn [frozen]="true">
									{{bonTravail().coutReelPieces | number : '1.2-2'}} $
								</td>
								<td alignFrozen="right" pFrozenColumn [frozen]="true">
									{{bonTravail().coutReelHeures}} Heures
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td [attr.colspan]="nombreColonnesTableauTravail()" class="text-center">
									<div class="flex flex-column align-items-center justify-content-center gap-2 py-5">
										<i class="pi pi-wrench text-4xl text-500"></i>
										<span class="text-500">Aucun travail.</span>
									</div>
								</td>
							</tr>
						</ng-template>
					</p-table>

					<!-------------  PIÈCES  -------------->

					@if (!bonTravail().indSoumission) {
						<div class="detail-bt-table-toolbar mt-4 pt-3 mb-3">
							<div class="detail-bt-table-toolbar__main flex flex-column md:flex-row md:align-items-center md:justify-content-between gap-3">
								<div class="flex align-items-center gap-2 min-w-0 flex-shrink-0">
									<h4 class="titreTableau m-0 text-lg font-semibold line-height-3">Pièces</h4>
									<p-tag
										[value]="(pieces()?.length ?? 0).toString()"
										severity="secondary"
										styleClass="text-xs font-normal"
										[pTooltip]="'Nombre de pièces'"
										tooltipPosition="top">
									</p-tag>
								</div>
								<div class="flex flex-column sm:flex-row flex-wrap align-items-stretch sm:align-items-center gap-2 w-full md:w-auto md:flex-1 md:justify-content-end min-w-0">
									<span class="p-input-icon-left detail-bt-table-toolbar__search w-full sm:w-auto">
										<i class="pi pi-search"></i>
										<input
											pInputText
											type="text"
											class="w-full"
											(input)="dtPieces.filterGlobal($event.target.value, 'contains')"
											placeholder="Rechercher dans les pièces..." />
									</span>
									<p-multiSelect
										optionLabel="header"
										selectedItemsLabel="{0} colonnes sélectionnées"
										[style]="{ minWidth: '12rem', maxWidth: '100%' }"
										styleClass="detail-bt-table-toolbar__columns w-full sm:w-auto"
										placeholder="Colonnes..."
										disabled>
									</p-multiSelect>
								</div>
							</div>

							@if (!modeConsultation()) {
								<div
									class="detail-bt-table-toolbar__actions flex flex-column sm:flex-row flex-wrap align-items-stretch sm:align-items-center justify-content-between gap-2 mt-3 pt-3">
									<div class="flex flex-wrap align-items-center gap-2 min-w-0 flex-1">
										@if (selectionMultiplePieces?.length) {
											<div class="detail-bt-table-toolbar__selection flex flex-wrap align-items-center gap-2 px-2 py-1 border-round w-full sm:w-auto">
												<span class="text-sm font-semibold white-space-nowrap">
													{{ selectionMultiplePieces.length }} sélectionnée(s)
												</span>
												<p-button
													label="Supprimer"
													icon="pi pi-trash"
													severity="danger"
													styleClass="p-button-sm p-button-outlined"
													[loading]="actionGroupeePiecesEnCours"
													[disabled]="actionGroupeePiecesEnCours"
													(onClick)="supprimerPieces($event, selectionMultiplePieces)">
												</p-button>
											</div>
										} @else {
											<span class="text-sm text-color-secondary">
												Ajoutez des pièces depuis le détail d'une étape ou sélectionnez des lignes pour supprimer en lot.
											</span>
										}
									</div>
								</div>
							}
						</div>
					}

					<p-table *ngIf="!bonTravail().indSoumission" #dtPieces [value]="pieces()" [columns]="selectedColumns"
						dataKey="pieceBonTravailId" tableStyleClass="tableNormale" autoLayout="true"
						[(selection)]="selectionMultiplePieces" 
						 [rowHover]="true" [filterDelay]="0"
						[globalFilterFields]="['item.numero','item.description','quantite']">
						<ng-template pTemplate="header" let-columns>
							<tr>
								<th *ngIf="!modeConsultation()" style="min-width: 3rem; width: 3rem;">
									<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
								</th>
								<th pSortableColumn="noEtape">
									<div class="flex justify-content-between align-items-center">
										#
										<p-sortIcon field="noEtape"></p-sortIcon>
									</div>
								</th>
								
								<th pSortableColumn="item.numero">
									<div class="flex justify-content-between align-items-center">
										Numéro
										<p-sortIcon field="item.numero"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="item.description">
									<div class="flex justify-content-between align-items-center">
										Description
										<p-sortIcon field="item.description"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="item.marque">
									<div class="flex justify-content-between align-items-center">
										Marque
										<p-sortIcon field="item.marque"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="item.modele">
									<div class="flex justify-content-between align-items-center">
										Modèle
										<p-sortIcon field="item.modele"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="quantite">
									<div class="flex justify-content-between align-items-center">
										Qte nécessaire
										<p-sortIcon field="quantite"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="qteInventaire">
									<div class="flex justify-content-between align-items-center">
										Qte inventaire
										<p-sortIcon field="qteInventaire"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="note">
									<div class="flex justify-content-between align-items-center">
										Note
										<p-sortIcon field="note"></p-sortIcon>
									</div>
								</th>
								<th style="min-width: 5rem; width: 5rem;"></th>

							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-entree let-columns="columns" let-index="rowIndex">
							<tr>
								<td *ngIf="!modeConsultation()">
									<p-tableCheckbox [value]="entree"></p-tableCheckbox>
								</td>
								<td><span class="clickable-etape" (click)="scrollToEtape(entree.noEtape)">{{entree.noEtape}}</span></td>
								<td>{{entree.item?.numero}}</td>
								<td>{{entree.item?.description}}</td>
								<td>{{entree.item?.marque}}</td>
								<td>{{entree.item?.modele}}</td>
								<td>{{entree.quantite}}</td>
								<td>
									<span [ngClass]="entree.qteInventaire && entree.qteInventaire > 0 ? entree.qteInventaire >= entree.quantite ? 'inventaire disponible' : 'inventaire insuffisant' : 'inventaire nondisponible'">
										{{entree.qteInventaire}}
									</span>
								</td>
								<td>
									<span class="formatted-text">{{entree.note}}</span>
									<button *ngIf="!modeConsultation()" pButton pRipple icon="pi pi-pencil"
										class="p-button-primary p-button-outlined mr-2 boutonGrille"
										(click)="modifierNotePiece($event, entree)"></button>
								</td>
								<td>
									<button *ngIf="!modeConsultation()" pButton pRipple icon="pi pi-trash"
										class="p-button-danger mr-2 boutonGrille"
										(click)="supprimerPieces($event, [entree])"></button>
									<button *ngIf="modeConsultation()" pButton pRipple icon="pi pi-bars"
										class="p-button-secondary mr-2 boutonGrille"
										(click)="surMenuContextuelPiece($event, entree)"></button>
								</td>

							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="9" class="text-center">
									<div class="flex flex-column align-items-center justify-content-center gap-2 py-5">
										<i class="pi pi-box text-4xl text-500"></i>
										<span class="text-500">Aucune pièce.</span>
									</div>
								</td>
							</tr>
						</ng-template>
					</p-table>

				</p-card>
			</p-tabPanel>
			<p-tabPanel header="Notes de l'unité" leftIcon="pi pi-pencil">
				<p-card>

					<div class="flex align-content-center justify-content-between mt-4 pt-3 mb-3">
						<div class="flex align-items-center gap-2">
							<span class="p-input-icon-left">
								<i class="pi pi-search"></i>
								<input pInputText type="text"
									(input)="dtNotes.filterGlobal($event.target.value, 'contains')"
									placeholder="Recherche..." />
							</span>
							
							<button *ngIf="estAutorise('item_note_creer') && !modeApercu" pButton pRipple icon="pi pi-plus"
								class="p-button-success"
								(click)="ajouterNoteUnite()"></button>
						</div>
						<h5 class="titreTableau m-0">Notes</h5>
						<div>
							<p-multiSelect disabled="true" [style]="{minWidth: '200px'}"
								placeholder="Colonnes..."></p-multiSelect>
						</div>
					</div>

					<p-table #dtNotes [value]="notes" dataKey="noteId" tableStyleClass="tableNormale"
							autoLayout="true"  [rowHover]="true"
							[filterDelay]="0" [globalFilterFields]="['description']">
							<ng-template pTemplate="header">
								<tr>
									<th pSortableColumn="date">
										<div class="flex justify-content-between align-items-center">
											Date
											<p-sortIcon field="date"></p-sortIcon>
										</div>
									</th>
									<th pSortableColumn="description">
										<div class="flex justify-content-between align-items-center">
											Note
											<p-sortIcon field="description"></p-sortIcon>
										</div>
									</th>
									<th pSortableColumn="demandeur.nom">
										<div class="flex justify-content-between align-items-center">
											Auteur
											<p-sortIcon field="demandeur"></p-sortIcon>
										</div>
									</th>
									<th *ngIf="!modeApercu" style="min-width: 5rem; width: 5rem;"></th>
								</tr>
							</ng-template>
							<ng-template pTemplate="body" let-note>

								<tr>
									<td>{{note.date | date:'yyyy-MM-dd'}}</td>
									<td>{{note.description}}</td>
									<td><app-employe-avec-emplacement [employe]="note.employe"></app-employe-avec-emplacement></td>
									<td *ngIf="!modeApercu">
										<button
											*ngIf="estAutorise('item_note_modifier') || estAutorise('item_note_supprimer')"
											pButton pRipple icon="pi pi-bars"
											class="p-button-secondary mr-2 boutonGrille"
											(click)="surMenuContextuelNote($event, note)"></button>
									</td>
								</tr>
							</ng-template>
							<ng-template pTemplate="emptymessage">
								<tr>
									<td colspan="4">Aucune note.</td>
								</tr>
							</ng-template>
						</p-table>

				</p-card>
			</p-tabPanel>
			<p-tabPanel *ngIf="!bonTravail().indSoumission" header="Garanties" leftIcon="pi pi-shield">
				<p-card>
					<p-card *ngIf="!chargementCompleteGaranties">
						<div class="fluid formgrid grid">
							<div class="flex flex-column gap-2 my-2 col-12 text-center">
								<p-progressSpinner></p-progressSpinner>
							</div>
						</div>
					</p-card>

					<p-table *ngIf="chargementCompleteGaranties" [value]="garanties" dataKey="garantieId"
						tableStyleClass="tableNormale" autoLayout="true" [rowHover]="true">
						<ng-template pTemplate="header">
							<tr>
								<th>Type</th>
								<th>Statut</th>
								<th>Date de début</th>
								<th>Date de fin</th>
								<th>Description</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-garantie>
							<tr>
								<td>{{ garantie.type?.nom | valeurVide }}</td>
								<td>
									<span *ngIf="garantie.statut" [class]="'statut ' + garantie.statut.nom.replace(' ','').toLowerCase()">
										{{ garantie.statut.nom }}
									</span>
									<span *ngIf="!garantie.statut">—</span>
								</td>
								<td>{{ garantie.dateDebut | date:'yyyy-MM-dd' | valeurVide }}</td>
								<td>{{ garantie.dateFin | date:'yyyy-MM-dd' | valeurVide }}</td>
								<td>{{ garantie.description | valeurVide }}</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="5" class="text-center">
									<div class="flex flex-column align-items-center justify-content-center gap-2 py-5">
										<i class="pi pi-shield text-4xl text-500"></i>
										<span class="text-500">Aucune garantie.</span>
									</div>
								</td>
							</tr>
						</ng-template>
					</p-table>
				</p-card>
			</p-tabPanel>
			<p-tabPanel header="Documents ({{this.documents?.length}})" leftIcon="pi pi-file">
				<ng-template pTemplate="content">
					<p-card>
						<app-document [typeLienDocument]="ETypeLienDocument.BonTravail" [idLien]="bonTravail().bonTravailId" [numero]="bonTravail().numero" [showFolders]="false"></app-document>
					</p-card>
				</ng-template>
			</p-tabPanel>
		</p-tabView>
	</div>